import { Button, ButtonVariant, Show } from "shared/components";

interface FreeCheckoutViewProps {
  isFeeWaived: boolean;
  isPaidInCash: boolean;
  isUpdatingPreferredCheckoutType: boolean;
  isSubmitting: boolean;
  onGoBack: () => void;
  onSubmit: () => void;
}

export const FreeCheckoutView = ({
  isFeeWaived,
  isPaidInCash,
  isUpdatingPreferredCheckoutType,
  isSubmitting,
  onGoBack,
  onSubmit
}: FreeCheckoutViewProps) => {
  return (
    <div className="bg-background-900">
      <div className="max-w-[400px] mx-auto flex h-[calc(80vh-154px)] items-center justify-center">
        <div>
          <div className="h-10 w-10 shrink-0 flex items-center justify-center mx-auto bg-primary-500 rounded-full mb-6">
            <span className="text-2xl font-bold text-center text-white">!</span>
          </div>

          <h1 className="text-lg font-bold text-content-1000 mb-2 text-center">
            {isFeeWaived
              ? "Application fee waived! Your application is complete."
              : "After this screen, you will not be able to edit the previously entered data"}
          </h1>
          <p className="text-base text-content-400 text-center">
            {isFeeWaived
              ? "No payment is required for this application."
              : "Please confirm that all the data you entered is correct and that you are ready to proceed"}
          </p>

          <Show if={isPaidInCash}>
            <p className="text-base font-medium text-content-600 text-center mt-4">
              Submit application only if applicant has already paid in cash.
            </p>
          </Show>
        </div>
      </div>
      <div className="bg-white mt-auto py-4 px-6 flex justify-end border-t border-alpha-100 gap-2">
        <Button
          className="w-[125px]"
          loading={isUpdatingPreferredCheckoutType}
          onClick={onGoBack}
        >
          Go back
        </Button>
        <Button
          className="w-[125px]"
          variant={ButtonVariant.PRIMARY}
          loading={isSubmitting}
          onClick={onSubmit}
        >
          {isFeeWaived ? "Complete Application" : "Accept"}
        </Button>
      </div>
    </div>
  );
};
